import { atom } from "jotai"

export const tableActionMenuOpenAtom = atom(false)
export const selectedTableCellNodeKey = atom<string | undefined>(undefined)
